import { NotFoundComponent } from './not-found/not-found.component';

export const containers = [NotFoundComponent];

export * from './not-found/not-found.component';
